import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import messages from './messages';
import EditNotificationForm from './EditNotificationForm';

class CreateNotification extends React.Component {
  static propTypes = {
    createNotification: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(formValues) {
    const notification = {
      title: formValues.title,
      message: formValues.message,
      priority: formValues.priority.value,
      datetime_from: moment(
        `${formValues.startDate} ${formValues.startTime.value}`,
        'DD.MM.YYYY HH:mm',
      ),
      datetime_to: moment(
        `${formValues.endDate} ${formValues.endTime.value}`,
        'DD.MM.YYYY HH:mm',
      ),
    };
    await this.props.createNotification(notification);
    this.props.history.push({ pathname: '/admin/notifications' });
  }

  render() {
    return (
      <div>
        <h2>
          <FormattedMessage {...messages.addHeading} />
        </h2>
        <EditNotificationForm
          onSubmit={this.handleSubmit}
          errors={this.state.errors}
        />
      </div>
    );
  }
}

const createNotificationMutation = gql`
  mutation createNotificationMutation($notification: NotificationInput!) {
    createNotification(notification: $notification) {
      id
      title
      message
      datetime_from
      datetime_to
      priority
      created_at
      updated_at
    }
  }
`;

export default compose(
  injectIntl,
  graphql(createNotificationMutation, {
    props: ({ mutate }) => ({
      createNotification: notification =>
        mutate({
          variables: { notification },
        }),
    }),
  }),
  connect(),
)(CreateNotification);
